const key = (companyId: string) =>
  `wembii_dismissed_notifications_${companyId}`;

export function loadDismissedNotificationIds(companyId: string): string[] {
  try {
    const raw = localStorage.getItem(key(companyId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveDismissedNotificationIds(
  companyId: string,
  ids: string[]
) {
  try {
    localStorage.setItem(key(companyId), JSON.stringify(ids));
  } catch {
    /* quota / private mode */
  }
}
